import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ICustomizationQuestion } from '../../store/slices/customization/customization';

interface Props {
  question: ICustomizationQuestion;
}

class BlockStyle extends Component<Props> {
  render() {
    const { question } = this.props;
    const questionFont = `font-family: ${question.font};`;
    const questionColor = `color: ${question.color};`;
    return (
      <style type="text/css" scoped>
        {`
          .ql-editor.ql-editor-to-show p,
          .ql-editor.ql-editor-to-show h1,
          .ql-editor.ql-editor-to-show h2,
          .ql-editor.ql-editor-to-show h3 {
            ${questionFont}
            ${questionColor}
          }
          .welcomeText {
            ${questionFont}
            ${questionColor}
          }
          .submittedInner {
            ${questionFont}
            ${questionColor}
          }
          .click-to-continue{
            ${questionFont}
            ${questionColor}
            font-size: 1.28571429em;
          }
        `}
      </style>
    );
  }
}

const mapStateToProps = (state) => {
  const { customization } = state;
  return {
    question: customization.question || {},
  };
};

export default connect(mapStateToProps)(BlockStyle);
